import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@maui/elements'

const InnerBox = Box.extend({
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
})

const OuterBox = ({ w, h, ...props }) => (
  <Box
    position="relative"
    _before={{
      content: '""',
      display: 'block',
      width: '100%',
      paddingTop: `${h / w * 100}%`,
    }}
    {...props}
  />
)

OuterBox.defaultProps = {
  w: 16,
  h: 9,
}

OuterBox.propTypes = {
  w: PropTypes.number,
  h: PropTypes.number,
}

export const RatioBox = ({ children, ...props }) => (
  <OuterBox {...props}>
    <InnerBox>
      {children}
    </InnerBox>
  </OuterBox>
)

RatioBox.InnerBox = InnerBox
RatioBox.OuterBox = OuterBox

RatioBox.propTypes = {
  w: PropTypes.number,
  h: PropTypes.number,
  children: PropTypes.node,
}
